import { Injectable } from '@angular/core';
import { jwtDecode, JwtPayload } from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class JwtService {

  constructor() { }

  /**
   * Check if a JWT token is expired.
   * @param token The JWT token.
   * @returns true if the token is expired, false otherwise.
   */
  isTokenExpired(token: string): boolean {
    try {
      // Decode the token to get its payload
      const decodedToken = jwtDecode<JwtPayload>(token);

      if (!decodedToken.exp) {
        // If the token does not have an 'exp' claim, consider it expired
        return true;
      }

      // Calculate the expiration time
      const expirationTime = decodedToken.exp * 1000; // Convert to milliseconds

      // Check if the current time is past the expiration time
      return Date.now() > expirationTime;
    } catch (error) {
      // If there's an error decoding the token, treat it as expired
      return true;
    }
  }
}
